import React, { useState } from 'react';
import { 
  AddCircleOutline as ExpandIcon,
  RemoveCircleOutline as CollapseIcon 
} from '@mui/icons-material';
import supportImg from '../../../assets/Imagenes/Planes_Futuro/Img.png';
import '../FAQ/styles.css';
import Typography from '@mui/material/Typography';
import ItacaWideBlack from '../../../assets/fonts/itaca/Itaca Wide Black.ttf';
import ItacaWideBold  from '../../../assets/fonts/itaca/Itaca-Wide-Bold.otf';
import ItacaWideDemiBold from '../../../assets/fonts/itaca/Itaca-Wide-DemiBold.otf';
import AlbertSansRegular from '../../../assets/fonts/Albert_Sans/AlbertSans-Regular.ttf';

// Inyecta todas las fuentes directamente
const fontStyles = `
@font-face {
  font-family: 'Itaca-Wide-Black';
  src: url(${ItacaWideBlack}) format('truetype');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-Bold';
  src: url(${ItacaWideBold}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-DemiBold';
  src: url(${ItacaWideDemiBold}) format('opentype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

  @font-face {
  font-family: 'Albert-Sans-Regular';
  src: url(${AlbertSansRegular}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
/* Agrega más @font-face para otras variantes si es necesario */
`;

// Crea y añade el elemento style al head
const styleElement = document.createElement('style');
styleElement.innerHTML = fontStyles;
document.head.appendChild(styleElement); 


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Función reutilizable para Typography con soporte responsive
  const renderText = (text, options = {}) => (
    <Typography
      component={options.component || 'p'} // etiqueta HTML que deseas: 'p', 'h1', 'div', etc.
      color={options.color || '#000000'}
      fontSize={options.fontSize || '18px'}
      fontFamily={options.fontFamily || '"Albert Sans", sans-serif'}
      display="inline"
      //fontWeight={options.fontWeight || 400}
      lineHeight={options.lineHeight || '100%'}
      sx={{
        '@media (max-width: 480px)': {
          fontSize: options.mobileFontSize || (options.fontSize === '42px' ? '32px' : '16px')
        },
        ...options.sx
      }}
      {...options}
    >
      {text}
    </Typography>
  );

  const faqItems = [
    {
      question: "¿Qué tipos de servicios ofrecen?",
      answer: "Servicios con velación en casa, velación en alguna de nuestras salas o servicios directos con conmemoraciones incluidas y todo lo necesario para llevar el funeral que desee que incluya cremación o entierro según su preferencia."
    },
    {
      question: "¿Qué incluye el servicio?",
      answer: "Traslado, preparación del cuerpo, ataúd, inhumación o cremación, set de velación, servicio de cafetería y los extras."
    },
    {
      question: "En caso de urgencia o duda, ¿se puede contactar a un asesor?",
      answer: (
    <>
      Sí, estamos contigo en todo el proceso 
      {renderText(" 24/7", { color: '#D14081', display: 'inline' })}. 
      Puedes marcar a nuestro número 
      {renderText(" 722 917 3720 ", { color: '#D14081', display: 'inline' })} 
      y recibirás una atención humana y personalizada.
    </>
  )
    },
    {
      question: "¿Cómo funciona la contratación en línea?",
      answer: "Envía un mensaje por WhatsApp, comparte tus datos de contratación y realiza el pago de tu anticipo en cualquiera de nuestras cuentas. Puedes hacerlo como prefieras: en efectivo, por transferencia o depósito. Una vez confirmado, recibirás tu contrato."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(prevIndex => prevIndex === index ? null : index);
  };

  return (
    <section className="faq-sectionQ" aria-labelledby="faq-heading">
      <div className="faq-header">
        <h2 id="faq-heading">
          {renderText("Preguntas frecuentes", {
            component: 'h2',
            color: '#D14081',
            fontSize: '42px',
            mobileFontSize: '25px !important',
            fontFamily: "'Itaca-Wide-Bold', sans-serif !important",
          })}
        </h2>
      </div>
      
      <div className="faq-container">
        <div className="faq-img">
          <img 
            src={supportImg} 
            alt="Asesor de soporte al cliente" 
            loading="lazy"
            width={500}
            height={350}
          />
        </div>
        
        <div className="faq-question-answer">
          {faqItems.map((faq, index) => (
            <div 
              key={`faq-${index}`}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <button 
                className="faq-question"
                onClick={() => toggleAccordion(index)}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <h3>
                  {renderText(faq.question, {
                    component: 'h3',
                    fontFamily: "'Itaca-Wide-Bold', sans-serif !important",
                    fontSize: '18px',
                    mobileFontSize: '16px !important'
                  })}
                </h3>
                {activeIndex === index ? (
                  <CollapseIcon className="expand-iconQ" aria-hidden="true" sx={{ fontSize: 16  }} />
                ) : (
                  <ExpandIcon className="expand-iconQ" aria-hidden="true" sx={{ fontSize: 16 }} />
                )}
              </button>
              <div 
                id={`faq-answer-${index}`}
                className="faq-answer"
                role="region"
              >
                <p>
                  {renderText(faq.answer, {
                    component: 'p',
                    fontFamily: "'Albert-Sans-Regular', sans-serif !important",
                    fontSize: '18px',
                    mobileFontSize: '16px !important'
                  })}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(FAQ);